import { useRef } from 'react'

import CloseIcon from 'mdi-react/CloseIcon'
import FocusLock from 'react-focus-lock'
import { connect, useDispatch, useSelector } from 'react-redux'

import { closePopup, getPopupContent, isPopupActive } from '@/ducks/popupReducer'
import useOnClickOutside from '@/hooks/useOnClickOutside'

import OnKeyDownCatcher from './OnKeyDownCatcher'

import './popup.scss'

const Popup = () => {
  const dispatch = useDispatch()

  const content = useSelector(getPopupContent)
  const isActive = useSelector(isPopupActive)
  const close = () => dispatch(closePopup())

  return (
    <div id="popup" className={`${!isActive ? 'inactive' : 'active'} ${!content && 'no-content'}`}>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
      <div id="popup__modal" className="no-select" onClick={close} />

      <Wrapper isActive={isActive} closePopup={close}>
        <div id="popup__content">
          <button onClick={close} id="popup__content__close">
            <CloseIcon />
          </button>

          {content}
        </div>
      </Wrapper>
    </div>
  )
}

const Wrapper = ({ isActive, closePopup, children }: any) => {
  const popupRef = useRef(null)

  useOnClickOutside(popupRef, () => isActive && closePopup)

  return isActive ? (
    <FocusLock>
      <div ref={popupRef}>
        <OnKeyDownCatcher onEsc={closePopup}>{children}</OnKeyDownCatcher>
      </div>
    </FocusLock>
  ) : (
    children
  )
}
// @ts-ignore
const mapStateToProps = state => ({
  content: getPopupContent(state),
  isActive: isPopupActive(state),
})

const mapDispatchToProps = {
  closePopup,
}

export default connect(mapStateToProps, mapDispatchToProps)(Popup)
